import { AuthState } from '../types';

export function logout(state: AuthState) {
  state.isLoggedIn = false;
  state.loading = false;
  state.error = null;

  localStorage.removeItem('app_logged_in');
}
